import { ICameraVOD } from '@thingsw/pitta-modules';

export function getVideoQuality(
  model: string,
  vod: ICameraVOD,
  isRearOnly: boolean
) {
  if (!model) {
    return undefined;
  }

  if (isRearOnly) {
    if (model.includes('ELITE 8') || model.includes('ELITE 9')) {
      return '2K';
    }

    if (model.includes('ELITE 10')) {
      return '4K';
    }

    return 'FHD';
  }

  if (model.includes('S')) {
    return undefined;
  }

  if (
    model.includes('970X') ||
    model.includes('900X') ||
    model.includes('ELITE 9') ||
    model.includes('ELITE 10')
  ) {
    if (vod.filename.includes('S') || vod.filename.includes('L')) {
      return 'Low';
    }
    return '4K';
  }

  if (
    model.includes('750G') ||
    model.includes('800G') ||
    model.includes('890') ||
    model.includes('ELITE 8')
  ) {
    if (vod.filename.includes('S') || vod.filename.includes('L')) {
      return 'Low';
    }
    return '2K';
  }

  if (
    model.includes('590G') ||
    model.includes('770X') ||
    model.includes('750X') ||
    model.includes('790X')
  ) {
    if (vod.filename.includes('S') || vod.filename.includes('L')) {
      return 'Low';
    }
    return 'FHD';
  }

  return undefined;
}
